import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconUnassigned(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 17.1414V16.25C3 13.9225 7.66375 12.75 10 12.75C12.3363 12.75 17 13.9225 17 16.25V17.1414C15.1962 18.9097 12.7255 20 10 20C7.27455 20 4.80375 18.9097 3 17.1414Z"
        fill="currentColor"
      />
      <path
        d="M10 4C8.06625 4 6.5 5.56625 6.5 7.5C6.5 9.43375 8.06625 11 10 11C11.9338 11 13.5 9.43375 13.5 7.5C13.5 5.56625 11.9338 4 10 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.04947 0.190319C8.68113 0.0653584 9.33343 0 10 0C10.6666 0 11.3189 0.0653584 11.9505 0.190319L11.5624 2.15229C11.0579 2.05249 10.5356 2 10 2C9.46444 2 8.94212 2.05249 8.43761 2.15229L8.04947 0.190319ZM15.5569 1.68494C16.6469 2.41473 17.5853 3.35306 18.3151 4.44314L16.6531 5.55578C16.0688 4.68294 15.3171 3.93123 14.4442 3.34688L15.5569 1.68494ZM1.68494 4.44314C2.41473 3.35306 3.35306 2.41474 4.44314 1.68494L5.55578 3.34688C4.68294 3.93123 3.93123 4.68294 3.34688 5.55578L1.68494 4.44314ZM0 10C0 9.33343 0.0653584 8.68113 0.190319 8.04947L2.15229 8.43761C2.05249 8.94212 2 9.46444 2 10C2 10.5356 2.05249 11.0579 2.15229 11.5624L0.190319 11.9505C0.0653584 11.3189 0 10.6666 0 10ZM19.8097 8.04947C19.9346 8.68113 20 9.33343 20 10C20 10.6666 19.9346 11.3189 19.8097 11.9505L17.8477 11.5624C17.9475 11.0579 18 10.5356 18 10C18 9.46444 17.9475 8.94212 17.8477 8.43761L19.8097 8.04947Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
